import React from 'react';

import { withInteractiveStore } from './TemplateWithInteractiveStore';
import { Attention, MiniHeader, SanitizedHtml } from '.';

const FieldCheckWithoutStore = React.memo(({assets,interactive,...props}) => {


  const { attention, bg, title, id, minutes, scenarios = [], responses } = interactive;


  const isActiveScreen = (screenNo) => {
    if (props.window) {
      return props.window.activeScreen === screenNo;
    } else if (screenNo === 1) {
      return true;
    } else {
      return false;
    }
  }


  const renderScenarioContent = scenario => {
    if (scenario.format === 'desk') {
      return (
        <>
          <div className="dinfos-fc__scenario-content">
            <SanitizedHtml content={scenario.content} />
          </div>
          <div className="dinfos-fc__scenario-paper-grad"></div>
        </>
      )
    } else if (scenario.format === 'image' && scenario.image && scenario.image.src)  {
      return <img src={assets[scenario.image.src]} alt={scenario.image.alt} data-src={scenario.image.src} />
    } else {
      return ''
    }
  }


  const renderChoices = (choices, questions, qIndex, scenarios, sIndex) => {
    if (!choices || !Array.isArray(choices)) {
      return '';
    }

    let next = "view your score";
    const scenarioNo = sIndex + 1;
    const questionNo = qIndex + 1;

    if (qIndex < questions.length) {
      next = "the next question";
    } else if (sIndex < scenarios.length) {
      next =  "the next scenario";
    }
    return choices.map((choice, cIndex) => {
      const choiceId = "choice-" + scenarioNo + questionNo + "-" + cIndex;
      
      return (
        <div key={cIndex} className="custom-control custom-radio dinfos-choice" >
          <input 
            type="radio" 
            className="custom-control-input" 
            id={choiceId}
            name={`"question-${scenarioNo}-${questionNo}`} 
            data-correct={choice.correct ? true : null} // can't print "false"; JS needs the attribute to not even be there.
            aria-live="off"
          />
          <label className="custom-control-label" htmlFor={choiceId}>
            {choice.text}
          </label>

          <div className="dinfos-choice__feedback" role="alert" aria-atomic="true">
            <div className="dinfos-choice__feedback-type">{ choice.correct ? 'Correct!' : 'Incorrect! Try again.' }</div>
            <span>{ choice.correct && choice.feedback ? choice.feedback : '' }</span>
            <span className="sr-only">{ choice.correct ? `Move on to ${next}` : ''}</span>
          </div>
        </div>
      )
    }) 
  }


  
  let scenariosText = 'Scenarios'
  if (scenarios && scenarios.length === 1) {
    scenariosText = "Scenario";
  }

  if (props.window) {
    props.window.responses = responses
  }



  return (
    <div id="interactive-template" ref={props.forwardedRef}>
      <script id="fc-script">
        window.responses = {JSON.stringify(responses)}
      </script>

      <article className="dinfos-fc" aria-live="polite" id={id}>

          <section className="dinfos-fc__screen dinfos-fc__screen--overview dinfos-fc__screen--active" data-screen="1" data-full-height="true">
            { bg && bg.src ? 
            <div className="dinfos-intv__bg">
              <img src={assets[bg.src]} alt="" data-src={bg.src}/>
            </div>
            : '' }
            <div className="container">
            
              <header className="dinfos-intv-header">
                <div className="dinfos-intv-header__bg-icon" aria-hidden="true"> 
                  {/* {% include "atoms-icon" with { class:"pavilion-icon",id:"ct_exercise"} %} */}
                </div>
                <h1 className="dinfos-intv-header__title">{title}</h1>
                <div className="dinfos-intv-header__supertitle">
                  <span>Exercise  </span><span><i className='far fa-clock'></i>{`  ${minutes ?  minutes : 0} min`}</span>
                </div>
              </header>

              <Attention 
                {...attention}
                pillText={scenarios.length + ' ' + scenariosText}
              />

            </div>
          </section>

          { !scenarios ? '' : 
            scenarios.map((scenario, sIndex) => {
              const scenarioNo = sIndex + 1;
              
              return (
                <section 
                  key={sIndex}
                  className={`dinfos-fc__screen dinfos-fc__screen--scenario dinfos-fc__screen--${scenario.format} ${isActiveScreen(scenarioNo + 1) ?  'dinfos-fc__screen--active' : ''}`}
                  data-screen={scenarioNo + 1}
                  // style={{backgroundImage: `url(${scenario.bg_img_src})`}}
                >
         
                  <MiniHeader 
                    btn={true} 
                    title={<>{"Exercise "}<span className='font-regular'>&nbsp;|&nbsp;</span>{` ${title}`}</>} 
                    details={`Scenario ${scenarioNo} of ${scenarios.length}`} 
                  />
                    
                  
                  <div className="container position-relative">
                    <div className="dinfos-fc__scenario">

                      {renderScenarioContent(scenario)}

                    </div>
                  </div>


                  {!scenario.questions ? '' :
                    <section className="dinfos-fc__drawer">
                      <header>

                        <h2 className="dinfos-fc__progress">
                          Answer Q. <span className="dinfos-fc__progress-current">1</span> of {scenario.questions.length}
                        </h2>

                        <button 
                          className="dinfos-fc__drawer-toggle dinfos-btn" 
                          type="button" 
                          aria-label="Toggle questions" 
                          data-toggle="collapse" 
                          data-target={`#drawer-content-${scenarioNo}`}
                          aria-expanded="true" 
                          aria-controls={`drawer-content-${scenarioNo}`}
                        ></button>

                      </header>

                      <div className="dinfos-fc__drawer-content collapse show" id={`drawer-content-${scenarioNo}`}>
                        {scenario.questions.map((question, qIndex) => {
                          const questionNo = qIndex + 1;
                          return (
                            <fieldset key={qIndex} className={`dinfos-fc__question-wrapper${qIndex === 0 ? ' dinfos-fc__question-wrapper--active' : ''}`} data-question-no={questionNo}>

                              <legend className="dinfos-fc__question">
                                <SanitizedHtml content={question.text} />
                              </legend>

                              <div className="dinfos-fc__nodes" aria-hidden="true">
                                {!question.choices || !Array.isArray(question.choices) ? '' :
                                  question.choices.map((choice, cIndex) => {
                                    const choiceId = "choice-" + scenarioNo + questionNo + "-" + cIndex;
                                    return (
                                      // eslint-disable-next-line
                                      <a 
                                        key={cIndex}
                                        href={`#${choiceId}`} 
                                        tabIndex="-1" 
                                        className={`dinfos-fc__node${ cIndex === 0 ? " dinfos-fc__node--active" : "" }`}
                                      ></a>
                                    )
                                  })
                                }
                                  
                              </div>

                              <div className="dinfos-fc__choices dinfos-drag-scroll-x">

                                {renderChoices(question.choices, scenario.questions, qIndex, scenarios, sIndex)}
                            
                              </div>
                              <div aria-live="polite">
                                <button className="btn dinfos-btn dinfos-btn--primary mx-auto d-block" type="button" disabled data-check-answer>Submit</button>
                                { qIndex !== scenario.questions.length - 1 ?
                                  <button className="btn dinfos-btn dinfos-btn--primary mx-auto d-none" type="button" data-next data-next-question>Next Question</button>
                                : 
                                  ( sIndex !== scenarios.length - 1 ?
                                    <button className="btn dinfos-btn dinfos-btn--primary mx-auto d-none" type="button" data-next data-next-screen>Next Scenario</button>
                                    :
                                    <button className="btn dinfos-btn dinfos-btn--primary mx-auto d-none" type="button" data-next data-score-fc>Check Your Score</button>
                                  )
                                }
                              </div>
                            </fieldset>
                          )
                        })}
                          
                        
                      </div>
                    </section>
                  }

                </section>
              )
            })
          }

          <section className="dinfos-fc__screen dinfos-fc__screen--results" data-screen={scenarios.length + 2} data-full-height="true">
            
            <MiniHeader title={<>{"Exercise "}<span className='font-regular'>&nbsp;|&nbsp;</span>{` ${title}`}</>} />
           
            <div className="container">
              <div className="dinfos-result">
                <div className="dinfos-result__score" data-percent="">
                  <svg className="dinfos-result__circle" preserveAspectRatio="xMinYMid" viewport="0 0 100 100" viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <circle className="dinfos-result__circle-bg" r="45" cx="50" cy="50" fill="transparent"  strokeDashoffset="0"></circle>
                    <circle className="dinfos-result__circle-bar"  r="45" cx="50" cy="50" fill="transparent" strokeDashoffset="0"></circle>
                  </svg>
                  <div className="dinfos-result__percent"></div>
                  <div className="dinfos-result__raw"><span className="dinfos-result__correct"></span> of <span className="dinfos-result__total"></span> Correct</div>
                </div>
                <div className="dinfos-result__title"></div>
                <hr className="dinfos-result__hr" />
                <div className="dinfos-result__feedback"></div>
                <div className="dinfos-result__end-buttons">
                  <button type="button" className="btn dinfos-btn dinfos-btn--tertiary dinfos-btn--icon-after" data-reload>Try Again <i className="fas fa-redo fa-icon"></i></button>
                  <a href="/Search-Results/Practice/" className="btn dinfos-btn dinfos-btn--primary dinfos-btn--action">Explore More</a>
                </div>
              </div>
            </div> 
          </section>

      </article>
    </div>
  )
})

export const FieldCheck = withInteractiveStore(
  FieldCheckWithoutStore,
);